import { FaExclamationTriangle } from "react-icons/fa";
import PropTypes from "prop-types";
import keyIcon from "../../images/Keys locked in car.svg";
import informationIcon from "../../images/Information.svg";

/**
 * Security alert component for displaying informational messages with icons
 * @param {Object} props - Component props
 * @param {string} props.message - Alert message to display
 * @param {string} [props.type='info'] - Alert type (info, warning, danger, success)
 * @param {React.Component} [props.icon=FaExclamationTriangle] - Icon component to display
 * @returns {JSX.Element} Rendered security alert
 */
export const SecurityAlert = ({
  message,
  type = "info",
  icon: IconComponent = FaExclamationTriangle,
}) => {
  return (
    <div className={`security-alert security-alert-${type} mb-4`}>
      <div className="d-flex align-items-center">
        <img src={informationIcon} alt="information icon" className="me-4" />
        <span className="security-alert-text">{message}</span>
      </div>
    </div>
  );
};

/**
 * User profile header component displaying user information and description
 * @param {Object} props - Component props
 * @param {string} props.name - User's display name
 * @param {string} props.email - User's email address
 * @param {React.Component} [props.icon] - Optional title icon component
 * @returns {JSX.Element} Rendered user profile header
 */
export const UserProfileHeader = ({ name, email, icon: IconComponent }) => {
  return (
    <div className="user-profile-header mb-4">
      <div className="user-profile-title-row">
        <img src={keyIcon} alt="Key Icon" />
        <p className="user-profile-subtitle mb-0">
          <h1 className="user-profile-title">Manage passkeys</h1>
          Use passkeys to sign in faster and more securely.
        </p>
      </div>
    </div>
  );
};

SecurityAlert.propTypes = {
  message: PropTypes.string.isRequired,
  type: PropTypes.oneOf(["info", "warning", "danger", "success"]),
  icon: PropTypes.elementType,
};

UserProfileHeader.propTypes = {
  name: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  icon: PropTypes.elementType,
};
